if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      get selectedOptionMainValues() {
        return Array.from(
          this.querySelectorAll('select option[selected], fieldset input:checked')
        ).map(el => el.value || el.textContent.trim());
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          
          var productVariants_json = document.querySelector('.product-inventory-data').getAttribute('data-product-json');
          var productVariants = JSON.parse(productVariants_json);


          var preorderIDs = document.querySelector('.product__inventory.main-pre').getAttribute('data-pre-ids');
          var MainSubmitButton = document.querySelector('.main-product .main-product-form .product-form__submit span');
          var MainSubmitButton_normal_txt = MainSubmitButton.getAttribute('data-main-text');
          var MainSubmitButton_pre_txt = MainSubmitButton.getAttribute('data-other-text');

          let is_pre_order = false;
          let is_out_of_stock = false;
          let is_normal = false;

        
            const matchedVariant = productVariants.find(variant => {
              return JSON.stringify(variant.options) === JSON.stringify(this.selectedOptionMainValues);
            });
          

            document.querySelectorAll('.product__inventory').forEach(function(el) {
                el.classList.remove('active');
            });

            if(matchedVariant != undefined){

            // console.log(matchedVariant);
            // console.log(matchedVariant.available);

              if(!matchedVariant.available){
                is_out_of_stock = true;
              }else{
                if (preorderIDs.includes(matchedVariant.id)) {
                  is_pre_order = true;
                } else {
                  is_normal = true;
                }
              }

              const MainDiv = document.querySelector('.product__inventory.main-default');
              if (MainDiv && is_normal) {
                MainDiv.classList.add('active');  
              }

              const MainOutDiv = document.querySelector('.product__inventory.main-out-of-stock');
              if (MainOutDiv && is_out_of_stock) {
                MainOutDiv.classList.add('active');  
              }

              const MainPreDiv = document.querySelector('.product__inventory.main-pre');
              if (MainPreDiv && is_pre_order) {
                MainPreDiv.classList.add('active'); 
              }

              if(is_pre_order && MainSubmitButton_pre_txt != ""){
                MainSubmitButton.style.setProperty('--text-var', `"${MainSubmitButton_pre_txt}"`);
              }else{
                MainSubmitButton.style.setProperty('--text-var', `"${MainSubmitButton_normal_txt}"`);
              }
            }else{
              const MainUnavailableDiv = document.querySelector('.product__inventory.main-unavailable');
              if (MainUnavailableDiv) {
                MainUnavailableDiv.classList.add('active');  
              }
               MainSubmitButton.style.setProperty('--text-var', '"IKKE TILGÆNGELIG"');
            }

          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}